import Helpers from '../modules/Helpers'

const activeClass = 'livechat--active';
const panels = document.getElementsByClassName('livechat__panel');
const startChat = document.getElementsByClassName('livechat__start');

window.Tawk_API = window.Tawk_API || {};

// Show header icon if we have chat agents online
window.Tawk_API.onStatusChange = function (status) {
    
    if (status === 'online') {
        new Helpers(panels).addClass(activeClass)
    } else {
        new Helpers(panels).removeClass(activeClass)
    }
};

// Toggle open/close of the chat widget
new Helpers(startChat).eventListener(() => {
    window.Tawk_API.toggle()
})


function handleNewsletterSignup(data) {
    try {
        // If label with "Newsletter" is present in the data, we've a positive newsletter sign up
        const newsLetterSignUp = data.some(item => item.label === "Newsletter");
        if (newsLetterSignUp) {
            const endpoint = '/ajax/newsletter.aspx';
            const formDataObj = {};

            // Iterate through the details array and populate the formDataObj
            data.forEach(item => {
            formDataObj[item.label.toLowerCase()] = item.answer;
            });

            // insert a source property
            formDataObj['source'] = 'tawk';
            formDataObj['list-name'] = 'chatBoxSignUp';

            // Convert the form data object to a URL-encoded string
            const urlEncodedData = new URLSearchParams(formDataObj).toString();

            // Create a URLSearchParams object with a "data" field containing the encoded form data
            const formBody = new URLSearchParams();
            formBody.append('data', urlEncodedData);

            // Fetch POST request to endpoint (we're not really bothered about the response, but commented out for ease of testing)
            fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formBody.toString()
            });
            //.then(response => {
            //    if (!response.ok) {
            //        throw new Error('Network response was not ok');
            //    }
            //    console.log('Newsletter signup details sent successfully');
            //})
            //.catch(error => {
            //    console.error('Error sending newsletter signup details:', error.message);
            //});
        }
    } catch (error) {
        //console.error(error);
    }
}

window.Tawk_API.onPrechatSubmit = function (data) {
    handleNewsletterSignup(data);
};

window.Tawk_API.onOfflineSubmit = function (data) {
    handleNewsletterSignup(data.questions);
};